export const requiredOnChange = {
  required: true, message: 'Đây là thông tin bắt buộc', trigger: 'change',
};
export const requiredOnBlur = {
  required: true, message: 'Đây là thông tin bắt buộc', trigger: 'change',
};
